import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "card border-0 rounded-0 bg-white authentication-card",
  style: {"margin-top":"100px !important"}
}
const _hoisted_2 = { class: "card-body letter-spacing" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h4", { class: "text-black fw-bold mb-0 text-center" }, " Veuillez vous connecter! ", -1)
const _hoisted_4 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Adresse mail ", -1)
const _hoisted_6 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Mot de passe ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center justify-content-between mb-15 mb-md-20" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "form-check form-check-primary mb-0 fs-md-15 fs-lg-16 text-muted lh-1" }, [
    /*#__PURE__*/_createElementVNode("input", {
      class: "form-check-input shadow-none",
      type: "checkbox",
      id: "remember-me"
    }),
    /*#__PURE__*/_createElementVNode("label", {
      class: "form-check-label",
      for: "remember-me"
    }, " Se souvenir de moi ")
  ])
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("button", {
  class: "default-btn transition border-0 fw-medium text-white rounded-1 fs-md-15 fs-lg-16 bg-success d-block w-100",
  type: "submit"
}, " Se connecter ", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "text-center mb-20 mb-md-25" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_Form, {
          ref: "loginForm",
          onSubmit: _ctx.onSubmitLogin,
          "validation-schema": _ctx.loginSchema
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createVNode(_component_Field, {
                name: "email",
                type: "text",
                class: "form-control shadow-none fs-md-15 text-black",
                placeholder: "Entrer votre email"
              }),
              _createVNode(_component_ErrorMessage, {
                name: "email",
                class: "text-danger"
              })
            ]),
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createVNode(_component_Field, {
                name: "password",
                type: "password",
                class: "form-control shadow-none fs-md-15 text-black",
                placeholder: "Entrer votre mot de passe"
              }),
              _createVNode(_component_ErrorMessage, {
                name: "password",
                class: "text-danger"
              })
            ]),
            _hoisted_8,
            _hoisted_9
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema"])
      ])
    ]),
    _hoisted_10,
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_router_link, {
        to: "/Regle-de-confidentialite",
        class: "text-decoration-none text-white"
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Règle de confidentialité ")
        ]),
        _: 1
      })
    ])
  ], 64))
}